<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Gửi tin nhắn tự động" :link="[{ text: 'Gửi tin nhắn tự động', href: '../post-send' }]" />
      </div>
    </div>
    <v-tabs v-model="tab" active-class="tab-active" class="mx-4" background-color="transparent">
      <v-tab class="tab-default" :key="1">Sổ điểm</v-tab>
      <v-tab class="tab-default" :key="2">Khen thưởng kỷ luật</v-tab>
      <v-tab class="tab-default" :key="3">Điểm danh</v-tab>
      <v-tab class="tab-default" :key="4">Học phí</v-tab>
    </v-tabs>
    <v-card class="px-md-6 mx-md-4 elevation-0" outlined>
      <v-tabs-items v-model="tab">
        <v-tab-item :key="1">
          <MarkPostCreate />
        </v-tab-item>
        <v-tab-item :key="2">
          <ViolationPostCreate />
        </v-tab-item>
        <v-tab-item :key="3">
          <AttendancePostCreate @sendDiligenceSMS="sendDiligenceSMS" />
        </v-tab-item>
        <v-tab-item :key="4">
          <TuitionFeePostCreate />
          <!-- <TuitionFeeLoadingLine /> -->
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <AttendancePostCreateDialog :state="sendDialog" :postTos="postTos" />
    <SendSMSExcelDialog :state="sendExcelDialog" />
  </div>
</template>

<script>
import SendSMSExcelDialog from '@/modules/sms/SendSMSExcelDialog'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import MarkPostCreate from '@/modules/post/MarkPostCreate.vue'
import ViolationPostCreate from '@/modules/post/ViolationPostCreate.vue'
import AttendancePostCreate from '@/modules/post/AttendancePostCreate.vue'
import AttendancePostCreateDialog from '@/modules/post/AttendancePostCreateDialog.vue'
import TuitionFeePostCreate from '@/modules/post/TuitionFeePostCreate.vue'
// import TuitionFeeLoadingLine from '@/modules/post/TuitionFeeLoadingLine.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    SendSMSExcelDialog,
    Breadcrumbs,
    MarkPostCreate,
    ViolationPostCreate,
    AttendancePostCreate,
    AttendancePostCreateDialog,
    TuitionFeePostCreate
    // TuitionFeeLoadingLine
  },
  data() {
    return {
      tab: 0,
      sendDialog: false,
      sendExcelDialog: false,
      postTos: {}
    }
  },
  computed: {
    ...mapGetters('auth', ['profile'])
  },
  methods: {
    // sendPost({ students, classes, grades, allSchool }) {
    //   this.postTos = { students, classes, grades, allSchool }
    //   this.sendDialog = !this.sendDialog
    // },
    async sendDiligenceSMS(data) {
      if (data.classes.length === 0) this.$alert.error('Xin vui lòng chọn ít nhất một lớp!')
      this.postTos = { classes: data.classes }
      this.sendDialog = !this.sendDialog
    }
  }
}
</script>

<style lang="scss" scoped></style>
